import PublishIcon from '@material-ui/icons/Publish';
import VocabularyManagerIcon from '../core/icons/VocabularyManager';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PageLayout from '../core/PageLayout';
import PrivateRoute from '../core/PrivateRoute';
import FullProjectImport from '../core/project/FullProjectImport';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../core/utils/constants';

const options = [
  {
    name: "Vocabulary Manager Home",
    url: '',
    icon: <VocabularyManagerIcon />
  },
  {
    name: "Import Project",
    url: 'import',
    entitlement: APPENTITLEMENTS.CAN_IMPORT_PROJECT,
    icon: <PublishIcon />
  }
];

class VocabularyManager extends Component {

  render() {

    const { applicationURL, applicationTitle } = this.props;

    const pageCrumb = <Switch>
      <Route path={applicationURL + "/import"} render={() => <span>Import Project</span>} />
      <Route path={applicationURL + "/"} render={() => <span>Projects Manager</span>} />
    </Switch>;

    return (
      <PageLayout
        title={applicationTitle}
        baseURL={applicationURL}
        graph=""
        id=""
        options={options}
        layoutTitle={function () { return (pageCrumb); }}
        breadcrumb={{
          baseURL: applicationURL,
          title: applicationTitle,
          static: pageCrumb,
          path: ["import"],
          url: {
            import: "import"
          }
        }}>
        <Switch>
          <PrivateRoute exact path={applicationURL + "/import"}
            entitlement={
              [
                APPENTITLEMENTS.CAN_IMPORT
              ]
            }
            component={FullProjectImport}
            projectType="https://grafsync.graphifi.com/schema/gs/TaxonomyProject"
            instructions="Please note that, if importing a project that contains associated ontology projects, you must import those ontology projects first."
            baseLink={applicationURL}
          />
          <Route render={() => <Redirect to={{ pathname: '/' }} />} />
        </Switch>
      </PageLayout>
    );
  }
}

VocabularyManager.propTypes = {
  applicationTitle: PropTypes.string.isRequired,
  applicationURL: PropTypes.string.isRequired
};

export default VocabularyManager;